<template>
<div class="chapter">
<div class="inner_page">
<a id="page_7"></a>
<h2 class="fm"><span class="bold">AUTHORS’ NOTE</span></h2>
<p class="noindent"><span class="dropcaps">M</span>any Welsh place names were spelt in two or more ways especially during the nineteenth century, e.g. Pantywaen or Pantywaun or Pant-y-Waun. We have used either/all the different spellings in this book so the reader has a flavour of the diversity. This also applied to people’s names e.g. Ifor or Ivor Works at Dowlais.</p>
<div class="img_container">
<img alt="images" src="images/f0007-1.jpg"/>
<p class="caption">Dowlais based TV 04 333 with a service to Pant or Pontsticill awaiting departure on 12 August 1939. (<span class="fn-1">F.K. Davies</span>)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Authors-Note.vue?c371abbc